import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import styled, { css } from 'styled-components';

import { TrackClick } from '@g4/trackster';

const MenuLinkImage = styled.img`
  max-height: 26px;
  max-width: 26px;
`;

const _MenuLink = props => {
  const { icon } = props;
  const attrs = _.omit(props, 'icon', 'alignIcon', 'center', 'isActive');

  return (
    <TrackClick
      action={'HO Top Nav'}
      label={
        props.children === 'Help' ? `Need ${props.children}` : props.children
      }
    >
      <a {...attrs}>
        {icon && <MenuLinkImage src={icon} alt="" />}
        {props.children}
      </a>
    </TrackClick>
  );
};

_MenuLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  /** Icon asset to display alongside the link text */
  icon: PropTypes.string,
  /** Vertically center content */
  center: PropTypes.bool,
  /** Styles the link as active */
  isActive: PropTypes.bool,
  /** Icon alignment */
  alignIcon: PropTypes.oneOf(['above', 'aside', 'center']),
};

_MenuLink.defaultProps = {
  center: false,
  alignIcon: 'aside',
};

const MenuLink = styled(_MenuLink)`
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
  align-items: flex-end;
  justify-content: flex-start;
  border-bottom: 5px solid transparent;

  font-size: 1rem;
  font-weight: 500;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-decoration: none;
  
  padding: ${props => props.theme.spacing(2)};

  
  

  ${MenuLinkImage} {
    margin-right: 5px;
  }

  ${props =>
    props.alignIcon === 'above' &&
    css`
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;

      ${MenuLinkImage} {
        margin-right: 0;
      }
    `} 
    
  ${props =>
    props.center &&
    css`
      align-items: center;

      /** Half the border width */
      padding-bottom: 2.5px;
    `}

    ${props =>
      props.alignIcon === 'center' &&
      css`
        ${MenuLinkImage} {
          margin-right: 0;
        }
      `}


  &:hover,
  &:focus {
    border-bottom-color: ${props => props.theme.colors.hob.topMenu.linkActive};
  }

  ${props =>
    props.isActive &&
    css`
      border-bottom-color: ${props =>
        props.theme.colors.hob.topMenu.linkActive};
    `};

  color: ${props => props.theme.colors.hob.topMenu.linkBg};

  ${props => props.theme.query.sm} {
    color: ${props => props.theme.colors.hob.topMenu.link};
    background-color: ${props => props.theme.colors.hob.topMenu.linkBg};
  }

  
    
`;

const MenuItem = styled.li`
  position: relative;
  display: flex;
`;

const MenuList = styled.ul`
  display: flex;
`;

const Menu = styled.div`
  position: relative;
  display: flex;
  height: 50px;

  ${props => props.theme.query.lg} {
    height: 70px;
  }
`;

export { MenuList, MenuLink, MenuItem, MenuLinkImage };
export default Menu;
